import Footer from '../../footer/Footer';
import Navbar from '../../navbar/Navbar';
import AboutLeftTab from '../../About/AboutLeftTab';

function HigherEducationSeminarJan2026() {

    const images = [
        "1000410626.jpg",
        "1000410629.jpg",
        "1000410632.jpg",
    ];

    return (
        <div>
            <Navbar />
            <div className="graduate-admission pt-lg-5 pt-4 pb-70">
                <div className="container">
                    <div className="row">
                        <AboutLeftTab />

                        <div className="col-lg-8 ps-lg-4 order-1 order-lg-2">
                            <div className="col-lg-12 ps-lg-4">
                                <div className="how-to-apply">
                                    <h2 className='pb-2'>
                                        Higher Education Seminar for Final Year Students – January 2026
                                    </h2>

                                    <p>
                                        A <strong>Higher Education Seminar</strong> focusing on
                                        <strong> career opportunities for graduates and career choices in 2026</strong>
                                        was conducted for final year students on <strong>5th January, 2026</strong>.
                                    </p>

                                    <div className="spotlight-group">
                                        <div className="row">
                                            {images.map((img, index) => (
                                                <div className="col-md-6 mb-3 mb-lg-4" key={index}>
                                                    <a
                                                        className="spotlight"
                                                        href={`https://admin.swec.ac.in/assetsswec/img/Higher-Education-Seminar-Jan-2026/${img}`}
                                                    >
                                                        <img
                                                            src={`https://admin.swec.ac.in/assetsswec/img/Higher-Education-Seminar-Jan-2026/${img}`}
                                                            alt={`Higher Education Seminar Image ${index + 1}`}
                                                            className="img-responsive center-block rounded overflow-hidden"
                                                        />
                                                    </a>
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <Footer />
        </div>
    )
}

export default HigherEducationSeminarJan2026;
